module.exports = __webpack_public_path__ + "static/hero-0d7db2277271ecf8a5588e6b109c3a26.jpg";